import unmute from 'unmute-ios-audio'

export function unmuteIosAudio() {
  unmute()
}
